export const Fonts = {
  regular: '"Red Hat", sans-serif',
  cool: '"Lalezar", sans-serif'
}
